import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PersonnePhysiqueDto } from 'src/api/models';

@Component({
  selector: 'app-exclude-infos-popup',
  templateUrl: './exclude-infos-popup.component.html',
  styleUrls: ['./exclude-infos-popup.component.css']
})
export class ExcludeInfosPopupComponent implements OnInit {
  @Input() personnePhysique: PersonnePhysiqueDto;
  @Input() public visible: boolean;
  @Output() onClosed = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  onHidden() {
    this.visible = false;
    this.onClosed.emit();
  }

}
